(function() {
  function hidePrimeReview(root) {
    const blocks = root.querySelectorAll
        ? root.querySelectorAll('.mxpr-block-product-review')
        : [];

    blocks.forEach(function(block) {
      const countEl = block.querySelector('.mxpr-summary__count');
      if (!countEl) return;

      const num = parseInt(countEl.textContent.replace(/\D/g, ''), 10) || 0;
      if (num === 0 && !block.closest('.customer-tag-gmt-staff')) {
        block.style.display = 'none';
      }
    });
  }

  hidePrimeReview(document);

  document.addEventListener('DOMContentLoaded', function() {
    hidePrimeReview(document);
  });

  window.addEventListener('load', function() {
    hidePrimeReview(document);
  });

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          hidePrimeReview(node);
        }
      });
    });
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  } else {
    window.addEventListener('load', function() {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }
})();